/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	theoreticalMax: number;
	finalActual: number;
	variance: number;
}
const MBYieldAccuracyAuditCard: React.FC<Props> = ({
	theoreticalMax,
	finalActual,
	variance,
}) => {
	const { t } = useTranslation();
	return (
		<div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
			<div className="flex items-center gap-4 mb-6">
				<div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center border border-emerald-100">
					<span className="material-symbols-outlined">rule</span>
				</div>
				<div>
					<h4 className="text-xs font-black text-slate-800 uppercase tracking-tight">
						{t("mediaReconcile.mediaBatch.yieldAccuracyAudit")}
					</h4>
					<p className="text-[10px] text-slate-400 font-bold uppercase">
						{t(
							"mediaReconcile.mediaBatch.comparingProducedUnits",
						)}
					</p>
				</div>
			</div>
			<div className="bg-slate-50 border border-slate-200 rounded-xl p-8 flex justify-around items-center">
				<div className="text-center">
					<p className="text-[9px] font-black text-slate-400 uppercase mb-2">
						{t("mediaReconcile.mediaBatch.theoreticalMax")}
					</p>
					<p className="text-4xl font-black text-slate-400 italic">
						{theoreticalMax}
					</p>
				</div>
				<div className="h-12 w-px bg-slate-200"></div>
				<div className="text-center">
					<p className="text-[9px] font-black text-slate-400 uppercase mb-2">
						{t("mediaReconcile.mediaBatch.finalActual")}
					</p>
					<p className="text-4xl font-black text-[#2D3E50]">
						{finalActual}
					</p>
				</div>
				<div className="h-12 w-px bg-slate-200"></div>
				<div className="text-center">
					<p className="text-[9px] font-black text-slate-400 uppercase mb-2">
						{t("mediaReconcile.mediaBatch.variance")}
					</p>
					<p className="text-4xl font-black text-red-500">{variance}</p>
				</div>
			</div>
		</div>
	);
};

export default MBYieldAccuracyAuditCard;
